export default __webpack_public_path__ + "profile_male.png";